import React, { useEffect, useState } from 'react'
import Layout from '../layouts/centered'
import CenteredForm from '../layouts/centered-form'
import { store } from '../store'
import { userActions } from '../functions/_actions'
import { history, resolveCallback } from '../functions/_helpers'

const SsoLogout = () => {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const callback = resolveCallback(params.get('callback'))

        // Reuse the existing logout mechanism (same as the confirmation modal),
        // but trigger it directly without asking the user to confirm.
        store.dispatch(userActions.logout())
        localStorage.clear()

        if (callback && callback.type === 'deep-link') {
            window.location.href = callback.value
        } else if (callback) {
            history.push(callback.path)
        } else {
            setIsLoading(false)
        }
    }, [])

    return (
        <Layout>
            <CenteredForm>
                <div className="w-full text-center">
                    {isLoading ? 'Logger ut...' : 'Du er nå logget ut.'}
                </div>
            </CenteredForm>
        </Layout>
    )
}

export default SsoLogout
